module.exports = __webpack_public_path__ + "static/media/corey_logo.713b2d43.png";